<template>
	<div v-show="showLottie" v-if="isImage">
		<vue-draggable-resizable
		:id='lottieIdPreview'
		class="element-position-lowerthird "
		:style="style"
		:class="className"
		v-if="status ==='preview'"
		:draggable="status ==='preview' && !item.is_locked  && !content.isPosition"
		:resizable="false"
		:x="parseInt(content.x)"
		:y="parseInt(content.y)"
		:lock-aspect-ratio="isLockRatio"
		:enable-native-drag="true"
		@dragstop="onDragstop"
		@resizestop="onResizstop"
		@dragging="onDrag"
		@resizing="onResize"
		:preventActiveBehavior="true"
		:parent="false">
			<div
			:style="styleWithScale"
			:width="widthElement"
			:height="heightElement"
			:id='lottieId'
			scrolling="no">
			</div>
		</vue-draggable-resizable>
		<div v-if="status === 'live'"
			class="element-position-lowerthird "
			:style="styleLive" >
			<div
				:id='lottieId'
				scrolling="no">
			</div>
		</div>
	</div>
</template>

<script>
import localforage from 'localforage';
import dayjs from 'dayjs';
import VueDraggableResizable from 'vue-draggable-resizable';
import rundownItemsApi from '@/api/rundownItems';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import { duplicateVar } from '@/lib/helper';
// import { duplicateVar } from '@/lib/helper';

/* eslint-disable no-restricted-globals */
/* eslint-disable no-param-reassign */
const lottiedatasample = { // default data variable
	pauseTimelineDuration: 4000,
	h1text: 'Bøaty McBøatfåce',
	h2text: 'Bright Yellow Submarine',
	h3text: 'Bøaty McBøatfåce',
	h4text: 'Bright Yellow Submarine',
	h5text: 'Bøaty McBøatfåce',
	h6text: 'Bright Yellow Submarine',
	h7text: 'Bøaty McBøatfåce',
	h8text: 'Bright Yellow Submarine',
	h9text: 'Bøaty McBøatfåce',
	h10text: 'Bright Yellow Submarine',
	h11text: 'Bøaty McBøatfåce',
	h12text: 'Bright Yellow Submarine',
	h13text: 'Bøaty McBøatfåce',
	h14text: 'Bright Yellow Submarine',
	h15text: 'Bøaty McBøatfåce',
	h16text: 'Bright Yellow Submarine',
	h17text: 'Bøaty McBøatfåce',
	h18text: 'Bright Yellow Submarine',
	h19text: 'Bøaty McBøatfåce',
	h20text: 'Bright Yellow Submarine',
	h21text: 'Bøaty McBøatfåce',
	h22text: 'Bright Yellow Submarine',
	h23text: 'Bøaty McBøatfåce',
	h24text: 'Bright Yellow Submarine',
	h25text: 'Bøaty McBøatfåce',
	h1color: '#ebe834',
	h2color: '#c40093',
	element1fill: '',
	element2fill: '',
	element3fill: '',
	element4fill: '',
	element1isgradient: false,
	element2isgradient: false,
	element3isgradient: true,
	element4isgradient: false,
	element1stroke: '#deb602',
	element2stroke: '#53de02',
	element3stroke: '#027af2',
	element4stroke: '#cc62fc',
};
export default {
	name: 'ElementLowerThird',
	props: {
		item: {
			type: Object,
		},
		status: {
			type: String,
		},
		delay: {
			type: Number,
		},
	},
	components: {
		'vue-draggable-resizable': VueDraggableResizable,
	},
	data() {
		return {
			datapath: '',
			container: null,
			changeValue: true, // switch
			isPausePlayback: true,
			isLoopPlayback: true,
			isAutoplay: true,
			showDebugger: true,
			lottiedata: null,
			// eslint-disable-next-line no-undef
			animax: lottie,
			isH1: '',
			isH2: '',
			isH3: '',
			isH4: '',
			isHasImage: '',
			EnableElement1: '',
			EnableElement2: '',
			EnableElement3: '',
			EnableElement4: '',
			isStrokeElement1: '',
			isStrokeElement2: '',
			isStrokeElement3: '',
			isStrokeElement4: '',
			isFillElement1: '',
			isFillElement2: '',
			isFillElement3: '',
			isFillElement4: '',
			isGradientElement1: '',
			isGradientElement2: '',
			isGradientElement3: '',
			isGradientElement4: '',
			animinend: '',
			h1color: '',
			h2color: '',
			h3color: '',
			h4color: '',
			repeatBreaker: false,
			timeoutState: null,
			showLottie: true,
			colorProperty: [
				'FillColor1', 'FillColor2',
				'FillColor3', 'FillColor4',
				'StrokeColor1', 'StrokeColor2',
				'StrokeColor3', 'StrokeColor4'],
			dropshadowenable: true,
			idxEnableDropShadow: null,
			firstInit: false,
			animationData: null,
			localItem: null,
			idxScale: 0,
			isGoingToDie: false,
		};
	},
	sockets: {
		connect() {
			// this.activateSocket();
		},
		async access_force_play_item(data) {
			// if (this.$route.name === 'DisplayLive') await this.sleep(this.delay ? this.delay : 0);
			if (this.localItem.id === data.id) {
				const dataContent = data.content && data.content !== ''
					? JSON.parse(data.content) : {};
				if (dataContent.h1 !== this.content.h1 && dataContent.h3 !== this.content.h3) {
					this.localItem = duplicateVar(data);
					this.$nextTick(() => {
						if (this.content) {
							const template = this.content.template ? this.content.template : null;
							if (template) {
								const url = template.file_path ? template.file_path : '';
								if (url) {
									const templateId = this.content && this.content.template && this.content.template.id ? this.content.template.id : null;
									const lottieKey = `lottie_lt_${templateId}`;
									localforage.getItem(lottieKey).then(async (value) => {
										if (value) {
											this.animationData = value;
										} else {
											this.animationData = await (await fetch(url)).json();
											const data = duplicateVar(this.animationData);
											// eslint-disable-next-line no-unused-vars
											localforage.setItem(lottieKey, data).then(() => localforage.getItem(lottieKey)).then((value) => {
												// we got our value
												// eslint-disable-next-line no-unused-vars
											}).catch((err) => {
												// we got an error
											});
										}
										this.$nextTick(() => {
											try {
												this.updatelottieparamAccess(this.animationData);
											} catch (error) {
											// console.log(error);
											}
										});
									// this.parseLottieData(data, isReset);
									});
								}
							}
						}
					});
				}
			}
			// updatelottieparamAccess
		},
		force_play_item(data) {
			if (this.localItem.id === data.id) {
				this.localItem = duplicateVar(data);
				this.$nextTick(() => {
					if (this.content) {
						const template = this.content.template ? this.content.template : null;
						if (template) {
							const url = template.file_path ? template.file_path : '';
							if (url) {
								const templateId = this.content && this.content.template && this.content.template.id ? this.content.template.id : null;
								const lottieKey = `lottie_lt_${templateId}`;
								localforage.getItem(lottieKey).then(async (value) => {
									if (value) {
										this.animationData = value;
									} else {
										this.animationData = await (await fetch(url)).json();
										const data = duplicateVar(this.animationData);
										// eslint-disable-next-line no-unused-vars
										localforage.setItem(lottieKey, data).then(() => localforage.getItem(lottieKey)).then((value) => {
											// we got our value
											// eslint-disable-next-line no-unused-vars
										}).catch((err) => {
											// we got an error
										});
									}
									this.$nextTick(() => {
										try {
											this.updatelottieparam(this.animationData);
										} catch (error) {
											// console.log(error);
										}
									});
									// this.parseLottieData(data, isReset);
								});
							}
						}
					}
				});
			}
		},
	},
	created() {
		this.localItem = duplicateVar(this.item);
	},
	methods: {
		sleep(ms) {
			return new Promise(
				resolve => setTimeout(resolve, ms),
			);
		},
		onDragstop(x, y) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const content = duplicateVar(this.content);
			content.x = x;
			content.y = y;
			// eslint-disable-next-line no-restricted-globals
			if (!x || isNaN(x)) {
				content.x = 0;
			} else {
				content.x = x;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!y || isNaN(y)) {
				content.y = 0;
			// eslint-disable-next-line no-restricted-globals
			} else {
				content.y = y;
			}
			content.position = 'custom';
			// if (this.content.position === 'default') {
			// 	content.y = 0;
			// }
			const params = {
				content: JSON.stringify(content),
				editPreview: 1,
			};
			rundownItemsApi.update(this.localItem.id, params, callback, errorCallback);
		},

		onResizstop() {
		},
		onDrag() {
		},
		onResize() {
		},
		floatnum(num) {
			return Math.round(parseInt(num, 16) / 255 * 1000000000000) / 1000000000000;
		},

		async forcePlay() {
			if (this.content) {
				const template = this.content.template ? this.content.template : null;
				if (template) {
					const url = template.file_path ? template.file_path : '';
					if (url) {
						// this.animationData = await (await fetch(url)).json();
						const templateId = this.content && this.content.template && this.content.template.id ? this.content.template.id : null;
						const lottieKey = `lottie_lt_${templateId}`;
						localforage.getItem(lottieKey).then(async (value) => {
							if (value) {
								this.animationData = value;
							} else {
								this.animationData = await (await fetch(url)).json();
								const data = duplicateVar(this.animationData);
								// eslint-disable-next-line no-unused-vars
								localforage.setItem(lottieKey, data).then(() => localforage.getItem(lottieKey)).then((value) => {
									// we got our value
								// eslint-disable-next-line no-unused-vars
								}).catch((err) => {
									// we got an error
								});
							}
							this.updatelottiedata(this.animationData);
							// this.parseLottieData(data, isReset);
						});
					}
				}
			}
		},

		updatelottiedata(data, isForcePlay = false) {
			// init template config\
			if (data && data.markers) {
				// eslint-disable-next-line eqeqeq
				this.animinend = (data.markers[1] !== undefined && data.markers[1].cm == 'OUT') ? Math.round(data.markers[1].tm) : 75; // default end in animation
				// default end in animation
				// eslint-disable-next-line eqeqeq
				if (data.layers[0].nm == 'OPT') {
					const opts = data.layers[0].ef;
					// eslint-disable-next-line no-undef
					$.each(opts, (j, efs) => {
						// eslint-disable-next-line eqeqeq
						if (jQuery.inArray(efs.nm, this.colorProperty) != -1) { // non Binary property
							opts[efs.nm] = efs.ef[0].v.k;
							opts[`idx${efs.nm}`] = j;
						} else {
							// eslint-disable-next-line eqeqeq
							opts[efs.nm] = (efs.ef[0].v.k != 0);
							// eslint-disable-next-line eqeqeq
							if (efs.nm == 'EnableDropShadow') this.idxEnableDropShadow = j;
							// eslint-disable-next-line eqeqeq
							if (efs.nm == 'Scale') this.idxScale = j;
						}
					});
					if (this.content.lottieScale && this.content.lottieScale === 'default') {
						data.layers[0].ef[this.idxScale].ef[0].v.k = 100;
					} else if (this.content.lottieScale && this.content.lottieScale === 'small') {
						data.layers[0].ef[this.idxScale].ef[0].v.k = 55;
					} else if (this.content.lottieScale && this.content.lottieScale === 'large') {
						data.layers[0].ef[this.idxScale].ef[0].v.k = 175;
					}


					// eslint-disable-next-line eqeqeq
					// if (this.content.lottieScale !== 'No scale') {
					if (this.content.lottieScale && this.content.lottieScale === 'default') {
						data.layers[0].ef[this.idxScale].ef[0].v.k = 100;
					} else if (this.content.lottieScale && this.content.lottieScale === 'small') {
						data.layers[0].ef[this.idxScale].ef[0].v.k = 55;
					} else if (this.content.lottieScale && this.content.lottieScale === 'large') {
						data.layers[0].ef[this.idxScale].ef[0].v.k = 175;
					}
					// }

					// config done, make the changes initlottie(lottiedata); //call it
					this.lottiedatachange(data, isForcePlay);
					const speedLottie = parseFloat(this.content.lottieSpeed) || 1;
					this.animax.setSpeed(speedLottie);
				}
			}
		},
		updatelottieparamAccess(data) {
			this.animax.destroy();
			this.updatelottiedata(data);
			this.animax.goToAndStop(0, true);
		},
		updatelottieparam(data) {
			this.animax.destroy();
			this.updatelottiedata(data, true);
			// setTimeout(() => {
			this.animax.goToAndStop(this.animinend, true);
			// }, 300);
		},
		lottiedatachange(data, isForcePlay = false) {
			// if (this.content && !this.content.isDefault) {
			$.each(data.layers, (k, obj) => {
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H1TEXT') {
					if (this.content.h1) obj.t.d.k[0].s.t = this.content.h1 ? this.content.h1 : lottiedatasample.h1text;
					if (this.content.h1_color) obj.t.d.k[0].s.fc = this.hexrgbobj(this.content.h1_color);
					if (this.content.h1_color) obj.ks.o.k = this.hexalpha(this.content.h1_color);
				}

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H2TEXT') {
					if (this.content.h2) obj.t.d.k[0].s.t = this.content.h2 ? this.content.h2 : lottiedatasample.h2text;
					if (this.content.h2_color) obj.t.d.k[0].s.fc = this.hexrgbobj(this.content.h2_color);
					if (this.content.h2_color) obj.ks.o.k = this.hexalpha(this.content.h2_color);
				}

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H3TEXT') {
					if (this.content.h3) obj.t.d.k[0].s.t = this.content.h3 ? this.content.h3 : lottiedatasample.h3text;
					if (this.content.h3_color) obj.t.d.k[0].s.fc = this.hexrgbobj(this.content.h3_color);
					if (this.content.h3_color) obj.ks.o.k = this.hexalpha(this.content.h3_color);
				}

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H4TEXT') {
					if (this.content.h4) obj.t.d.k[0].s.t = this.content.h4 ? this.content.h4 : lottiedatasample.h4text;
					if (this.content.h4_color) obj.t.d.k[0].s.fc = this.hexrgbobj(this.content.h4_color);
					if (this.content.h4_color) obj.ks.o.k = this.hexalpha(this.content.h4_color);
				}

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H5TEXT') { if (this.content.h5) obj.t.d.k[0].s.t = this.content.h5 ? this.content.h5 : lottiedatasample.h5text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H6TEXT') { if (this.content.h6) obj.t.d.k[0].s.t = this.content.h6 ? this.content.h6 : lottiedatasample.h6text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H7TEXT') { if (this.content.h7) obj.t.d.k[0].s.t = this.content.h7 ? this.content.h7 : lottiedatasample.h7text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H8TEXT') { if (this.content.h8) obj.t.d.k[0].s.t = this.content.h8 ? this.content.h8 : lottiedatasample.h8text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H9TEXT') { if (this.content.h9) obj.t.d.k[0].s.t = this.content.h9 ? this.content.h9 : lottiedatasample.h9text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H10TEXT') { if (this.content.h10) obj.t.d.k[0].s.t = this.content.h10 ? this.content.h10 : lottiedatasample.h10text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H11TEXT') { if (this.content.h11) obj.t.d.k[0].s.t = this.content.h11 ? this.content.h11 : lottiedatasample.h11text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H12TEXT') { if (this.content.h12) obj.t.d.k[0].s.t = this.content.h12 ? this.content.h12 : lottiedatasample.h12text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H13TEXT') { if (this.content.h13) obj.t.d.k[0].s.t = this.content.h13 ? this.content.h13 : lottiedatasample.h13text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H14TEXT') { if (this.content.h14) obj.t.d.k[0].s.t = this.content.h14 ? this.content.h14 : lottiedatasample.h14text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H15TEXT') { if (this.content.h15) obj.t.d.k[0].s.t = this.content.h15 ? this.content.h15 : lottiedatasample.h15text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H16TEXT') { if (this.content.h16) obj.t.d.k[0].s.t = this.content.h16 ? this.content.h16 : lottiedatasample.h16text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H17TEXT') { if (this.content.h17) obj.t.d.k[0].s.t = this.content.h17 ? this.content.h17 : lottiedatasample.h17text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H18TEXT') { if (this.content.h18) obj.t.d.k[0].s.t = this.content.h18 ? this.content.h18 : lottiedatasample.h18text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H19TEXT') { if (this.content.h19) obj.t.d.k[0].s.t = this.content.h19 ? this.content.h19 : lottiedatasample.h19text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H20TEXT') { if (this.content.h20) obj.t.d.k[0].s.t = this.content.h20 ? this.content.h20 : lottiedatasample.h20text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H21TEXT') { if (this.content.h21) obj.t.d.k[0].s.t = this.content.h21 ? this.content.h21 : lottiedatasample.h21text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H22TEXT') { if (this.content.h22) obj.t.d.k[0].s.t = this.content.h22 ? this.content.h22 : lottiedatasample.h22text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H23TEXT') { if (this.content.h23) obj.t.d.k[0].s.t = this.content.h23 ? this.content.h23 : lottiedatasample.h23text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H24TEXT') { if (this.content.h24) obj.t.d.k[0].s.t = this.content.h24 ? this.content.h24 : lottiedatasample.h24text; }
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H25TEXT') { if (this.content.h25) obj.t.d.k[0].s.t = this.content.h25 ? this.content.h25 : lottiedatasample.h25text; }

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'ELEMENT1' && this.content.color_1) {
					$.each(obj.shapes[0].it, (j, objel1) => {
						// eslint-disable-next-line eqeqeq
						if (this.content.color_1) this.elgradfill(objel1, this.content.gradient ? this.content.gradient : false, this.content.color_1, 1);
						// eslint-disable-next-line eqeqeq
						if (this.content.color_1 && objel1.ty == 'st') objel1.c.k = this.hexrgbarr(this.content.color_1);
					});
				}

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'ELEMENT2' && this.content.color_2) {
					$.each(obj.shapes[0].it, (j, objel2) => {
						// eslint-disable-next-line eqeqeq
						if (this.content.color_2) this.elgradfill(objel2, this.content.gradient ? this.content.gradient : false, this.content.color_2, 1);
						// eslint-disable-next-line eqeqeq
						if (this.content.color_2 && objel2.ty == 'st') objel2.c.k = this.hexrgbarr(this.content.color_2);
					});
				}

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'ELEMENT3' && this.content.color_3) {
					$.each(obj.shapes[0].it, (j, objel3) => {
						// eslint-disable-next-line eqeqeq
						if (this.content.color_3) this.elgradfill(objel3, this.content.gradient ? this.content.gradient : false, this.content.color_3, 1);
						// eslint-disable-next-line eqeqeq
						if (this.content.color_3 && objel3.ty == 'st') objel3.c.k = this.hexrgbarr(this.content.color_3);
					});
				}
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'ELEMENT4' && this.content.color_4) {
					$.each(obj.shapes[0].it, (j, objel4) => {
						// eslint-disable-next-line eqeqeq
						if (this.content.color_4) this.elgradfill(objel4, this.content.gradient ? this.content.gradient : false, this.content.color_4, 1);
						// eslint-disable-next-line eqeqeq
						if (this.content.color_4 && objel4.ty == 'st') objel4.c.k = this.hexrgbarr(this.content.color_4);
					});
				}
				// eslint-disable-next-line eqeqeq
				if (obj && obj.ef && obj.ef[0] && obj.ef[0].nm == 'isHasImage') {
					// eslint-disable-next-line eqeqeq
					this.isHasImage = obj.ef[0].ef[0].v.k;
					// array does not exist, is not an array, or is empty
					// ⇒ do not attempt to process array
				}
			});

			lottiedatasample.element1fill = this.content.color_1;
			lottiedatasample.element2fill = this.content.color_2;
			lottiedatasample.element3fill = this.content.color_3;
			lottiedatasample.element4fill = this.content.color_4;

			// ensure the color folow the global option color for all element
			// for (let idx = 1; idx < 5; idx++) {
			// 	if (data.layers[0].ef) {
			// 		if (lottiedatasample[`element${idx}fill`]) data.layers[0].ef[parent[`idxFillColor${idx}`]].ef[0].v.k = this.hexrgbarr(''); // global color method, works on all layer, except gradient fill
			// 	}
			// 	// console.log(parent[`idxFillColor${idx}`]);
			// 	// console.log(this.hexrgbarr(''));
			// }
			let mediaUrl = this.content.mediaUrl;
			if (Array.isArray(data.assets) && data.assets.length && this.isHasImage) {
				localforage.getItem(`media_${this.content.mediaId}`, (err, value) => {
					if (!err && value) {
						const mediaSource = URL.createObjectURL(value);
						mediaUrl = mediaSource;
					} else {
						mediaUrl = this.content.mediaUrl;
					}
					if (this.content.mediaUrl && data.assets.length >= 1) data.assets[0].u = mediaUrl;
					if (this.content.mediaUrl && data.assets.length >= 1) data.assets[0].p = '';
					if (this.content.mediaUrl1 && data.assets.length >= 1) data.assets[0].u = this.content.mediaUrl1;
					if (this.content.mediaUrl1 && data.assets.length >= 1) data.assets[0].p = '';
					if (this.content.mediaUrl2 && data.assets.length >= 2) data.assets[1].u = this.content.mediaUrl2;
					if (this.content.mediaUrl2 && data.assets.length >= 2) data.assets[1].p = '';
					if (this.content.mediaUrl3 && data.assets.length >= 3) data.assets[2].u = this.content.mediaUrl3;
					if (this.content.mediaUrl3 && data.assets.length >= 3) data.assets[2].p = '';
					if (this.content.mediaUrl4 && data.assets.length >= 4) data.assets[3].u = this.content.mediaUrl4;
					if (this.content.mediaUrl4 && data.assets.length >= 4) data.assets[3].p = '';
					if (this.content.mediaUrl5 && data.assets.length >= 5) data.assets[4].u = this.content.mediaUrl5;
					if (this.content.mediaUrl5 && data.assets.length >= 5) data.assets[4].p = '';
					if (this.content.mediaUrl6 && data.assets.length >= 6) data.assets[5].u = this.content.mediaUrl6;
					if (this.content.mediaUrl6 && data.assets.length >= 6) data.assets[5].p = '';
					if (this.content.mediaUrl7 && data.assets.length >= 7) data.assets[6].u = this.content.mediaUrl7;
					if (this.content.mediaUrl7 && data.assets.length >= 7) data.assets[6].p = '';
					if (this.content.mediaUrl8 && data.assets.length >= 8) data.assets[7].u = this.content.mediaUrl8;
					if (this.content.mediaUrl8 && data.assets.length >= 8) data.assets[7].p = '';
					if (this.content.mediaUrl9 && data.assets.length >= 9) data.assets[8].u = this.content.mediaUrl9;
					if (this.content.mediaUrl9 && data.assets.length >= 9) data.assets[8].p = '';
					if (this.content.mediaUrl10 && data.assets.length >= 10) data.assets[9].u = this.content.mediaUrl10;
					if (this.content.mediaUrl10 && data.assets.length >= 10) data.assets[9].p = '';
					// setTimeout(() => {
					this.initlottie(data, isForcePlay);
					// }, 300);
				});
			} else {
				if (this.idxEnableDropShadow) {
					data.layers[0].ef[this.idxEnableDropShadow].ef[0].v.k = this.content.textDropShadow ? 1 : 0; // dropshadow toggle
				}
				// setTimeout(() => {
				this.initlottie(data, isForcePlay);
				// }, 300);
			}
		},

		rgbaobjtohex(obj) {
			const r = Math.round(obj[0] * 255);
			const g = Math.round(obj[1] * 255);
			const b = Math.round(obj[2] * 255);
			const a = (obj[3] !== undefined) ? Math.round(obj[3] * 255).toString(16) : '';
			// eslint-disable-next-line no-bitwise
			return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}${a}`;
		},
		hexrgbobjgrad(hex) {
			const xhex = (hex.length === 7) ? hex : hex.slice(0, -2);
			const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(xhex);
			const baser = this.floatnum(result[1]); // red
			const baseg = this.floatnum(result[2]); // green
			const baseb = this.floatnum(result[3]); // blue
			const grdratio = [1.3, 1.8]; // less
			return result ? {
				0: 0,
				1: baser, // red
				2: baseg, // green
				3: baseb, // blue
				4: 0.5,
				5: baser / grdratio[0], // red gradient
				6: baseg / grdratio[0], // green gredien
				7: baseb / grdratio[0], // blue gradien
				8: 1,
				9: baser / grdratio[1],
				10: baseg / grdratio[1],
				11: baseb / grdratio[1],
			} : null;
		},
		hexrgbobj(hex) {
			const xhex = (hex.length === 7) ? hex : hex.slice(0, -2);
			const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(xhex);
			return result ? {
				0: this.floatnum(result[1]),
				1: this.floatnum(result[2]),
				2: this.floatnum(result[3]),
				3: 1,
			} : null;
		},
		hexrgbarr(hex) {
			const xhex = (hex.length === 7) ? hex : hex.slice(0, -2);
			const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(xhex);
			return result ? [
				this.floatnum(result[1]),
				this.floatnum(result[2]),
				this.floatnum(result[3]),
				1,
			] : null;
		},
		hexalpha(hex) {
			return (hex.length !== 9) ? 100 : this.floatnum(hex.slice(-2)).toFixed(2) * 100;
		},

		elgradfill(obj, flag, hex) {
			if (obj.ty === 'gf') {
				if (flag) {
					obj.g.k.k = this.hexrgbobjgrad(hex); // get gradient from hex rgb
					obj.o.k = this.hexalpha(hex);
				} else {
					obj.o.k = 0;
				}
			}

			if (obj.ty === 'fl') {
				if (!flag) {
					obj.c.k = this.hexrgbarr(hex);// get array rgb from hex
					obj.o.k = this.hexalpha(hex);
				} else {
					obj.o.k = 0;
				}
			}
		},
		stringToSeconds(sec) {
			const hms = sec; // your input string
			const a = hms.split(':'); // split it at the colons
			// eslint-disable-next-line no-restricted-globals
			const first = isNaN((+a[0]) * 60 * 60) ? 0 : (+a[0]) * 60 * 60;
			// eslint-disable-next-line no-restricted-globals
			const second = isNaN((+a[1]) * 60 * 60) ? 0 : (+a[1]) * 60;
			// eslint-disable-next-line no-restricted-globals
			const third = isNaN((+a[2])) ? 0 : (+a[2]);
			// minutes are worth 60 seconds. Hours are worth 60 minutes.
			const seconds = first + second + third;
			return seconds;
		},
		playbackPauseDuration() {
			// init >   msg, duration-in-seconds, foreground-color, background-color
			console.log('now in pause state');
			const seconds = this.content.duration ? this.stringToSeconds(this.content.duration) : 0; // your input string
			console.log('total second paused content: ', seconds);
			this.animax.pause(); // another pause call just to make sure.
			if (seconds > 0) { // check if the duration set to 0 - infinite or manual stop
				this.timeoutState = setTimeout(this.playResumeAnimation, (seconds) * 1000); // set timeout to call the animation OUT
			}
			// if is update true clear interval
		},
		playResumeAnimation() { // animation OUT playback
			// emit disini untuk pause otomatis jika tidak di pause manual
			console.log('now in resume state');
			this.isGoingToDie = true;
			this.animax.play();
		},
		killAnimationImmediatelly() { // animation OUT playback
			console.log('now in kill animation immadiatelly');
			if (this.timeoutState !== undefined) {
				this.animax.goToAndPlay(this.animinend, true); // timeout has been set go to 'OUT' point
			}
			clearTimeout(this.timeoutState);
			this.timeoutState = undefined;
		},
		stopAll() {
			const callback = () => {
				// const data = response.data;
				// executeCallbackOnce++; // stop next execution
			};
			const errorCallback = () => {
			};
			if (this.status === 'live') {
				if (this.content && this.content.onCompleteItem) {
					this.onCompletePlay(this.content.onCompleteItem);
				}
			}
			rundownItemsApi.stopAll(this.localItem.id, this.status, callback, errorCallback); // stop the lower third automatically
		},
		initlottie(data, isForcePlay = false) {
			const container = document.getElementById(this.lottieId);
			const animcomp = {
				name: this.lottieId,
				container,
				renderer: 'svg',
				animationData: data,
				loop: false,
				prerender: true,
				autoplay: 1,
				useSubFrames: false,
				progressiveLoad: true,
				rendererSettings: {
					filterSize: {
						width: '200%',
						height: '200%',
						x: '-50%',
						y: '-50%',
					},
				},
			};


			// eslint-disable-next-line no-undef
			this.animax = lottie.loadAnimation(animcomp);
			this.showLottie = false;

			if (isForcePlay) this.animax.goToAndStop(this.animinend, true);

			if (this.status === 'live') {
				this.liveLowerThird();
			}

			if (this.status === 'preview') {
				this.previewLowerThird();
			}
		},
		previewLowerThird() {
			this.showLottie = true;
			let executeOnce = 1;
			let executeCallbackOnce = 1; // to make sure this only run once
			this.animax.addEventListener('enterFrame', () => {
				const isPausePlayback = this.stringToSeconds(this.content.duration) > 0; // first check if duration more than 0 seconds
				if (isPausePlayback) { // if there's a duration then
					// check the current frame running and check if the current frame is same as end of mid animation
					if (Math.round(this.animax.currentFrame) === this.animinend && executeOnce === 1) { /*
						because this likely to execute more than one so we need to make sure only execute 1 time */
						executeOnce++;
						this.playbackPauseDuration(); // here we pause the animation depend on the this.content.duration time
					}

					if (this.animax.currentFrame === this.animax.totalFrames - 1 && executeCallbackOnce === 1) {
						this.stopAll();
						executeCallbackOnce++;
					}
				}
			});
		},
		liveLowerThird() {
			let executeCallbackOnce = 1; // to make sure this only run once
			let executeOnce = 1;
			let stopOnce = 1;
			this.showLottie = true;

			this.animax.addEventListener('enterFrame', () => {
				if (this.animax.currentFrame > 1) { // check if lottie start playing
					if (this.localItem.is_update_live && stopOnce === 1 && this.localItem.is_wait_play) { // check if item is ready to play and standby to be playing
						console.log('now in enterFrame on pause another item state');
						this.animax.pause(); // pause first to wait and still hidden
						stopOnce++; // stop to execute this only once
					} else if (this.localItem.is_update_live && stopOnce === 1 && !this.localItem.is_wait_play) {
						// check if item ready to play and ready to take in to the live
						console.log('now in enterFrame on playBy another item state');

						this.animax.play(); // play the lottie engine
						this.showLottie = true; // show the lower third
						stopOnce++; // stop to execute this only once
					}

					const isPausePlayback = this.stringToSeconds(this.content.duration) > 0; // first check if duration more than 0 seconds
					if (isPausePlayback && this.localItem.is_update_live && !this.localItem.is_wait_play) { // if there's a duration then
						// check the current frame running and check if the current frame is same as end of mid animation
						// console.log('masuk sini ges', this.localItem.name, Math.round(this.animax.currentFrame), this.animinend);
						if ((Math.round(this.animax.currentFrame) === this.animinend
							|| Math.round(this.animax.currentFrame) === this.animinend + 1
							|| Math.round(this.animax.currentFrame) === this.animinend - 1) && executeOnce === 1) { /*
							because this likely to execute more than one so we need to make sure only execute 1 time */
							// this.showLottie = true;
							console.log('now in enterFrame on calling pause by marker');
							executeOnce++;
							this.playbackPauseDuration(); // here we pause the animation depend on the this.content.duration time
						}
					}
					// check if the current frame is same as total frame minus 1
					// it's minus 1 because animation end in frame 124 for example and total frame is 125 so we need to step down the total frame
					// console.log(this.localItem.name, this.animax.currentFrame, this.animax.totalFrames, executeOnce);
					if (Math.round(this.animax.currentFrame) === this.animax.totalFrames - 1
					&& executeCallbackOnce === 1) {
						console.log('now in end of animation state');

						this.stopAll();
						executeCallbackOnce++;
					}
				}
			});
		},
		onPlayLive() {
			if (this.localItem.is_update_live && this.localItem.is_wait_play) {
				this.animax.pause();
			}
			if (!this.localItem.is_update_live && !this.localItem.is_wait_play) {
				// this.showLottie = true;
				this.killAnimationImmediatelly();
			}
			if (!this.localItem.is_update_live) {
				this.isGoingToDie = true;
			}
			if (this.localItem.is_update_live && !this.localItem.is_wait_play) {
				this.showLottie = true;
				console.log('now in playnext by another item state');
				clearTimeout(this.timeoutState);
				this.animax.play();
			}
		},
		onPlayPreview() {
			if (!this.localItem.is_update_preview) {
				this.killAnimationImmediatelly();
			}
		},
		onCompletePlay(itemId) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			rundownItemsApi.playLive(itemId, callback, errorCallback);
		},
	},
	mounted() {
		this.forcePlay();
	},
	beforeDestroy() {
		this.animax.destroy();
	},
	computed: {
		isLockRatio() {
			return this.content && this.content.isRatio ? this.content.isRatio : false;
		},
		widthElement() {
			const content = this.content;
			const width = content && content.width ? content.width : 100;
			return width;
		},
		heightElement() {
			const content = this.content;
			const height = content && content.height ? content.height : 100;
			return height;
		},
		lottieId() {
			return `${this.localItem.slug}-${this.status}-${this.localItem.id}`;
		},
		lottieIdPreview() {
			return `preview${this.localItem.slug}-${this.status}-${this.localItem.id}`;
		},
		content() {
			return this.localItem.content && this.localItem.content !== ''
				? JSON.parse(this.localItem.content) : {};
		},
		className() {
			return this.content.position ? this.content.position : '';
		},
		style() {
			const style = {};
			style.position = 'absolute';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content) {
				if (content.opacity) style.opacity = content.opacity;
			}
			return style;
		},
		styleWithScale() {
			const style = {};
			style.position = 'absolute';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = '100%';
			// if (content.lottieScale && content.lottieScale === 'default') {
			// 	style.transform = 'scale(1) ';
			// } else if (content.lottieScale && content.lottieScale === 'small') {
			// 	style.transform = 'scale(0.5)';
			// } else if (content.lottieScale && content.lottieScale === 'large') {
			// 	style.transform = 'scale(2)';
			// }
			return style;
		},
		styleLive() {
			const style = {};
			style.position = 'absolute';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;

			style.top = `${content.y}px`;
			style.left = `${content.x}px`;
			return style;
		},
		isImage() {
			return this.localItem.type === 'lower_third';
		},
	},
	watch: {
		item() {
			if (this.item) {
				const currentItemUpdatedDate = dayjs(this.localItem.updated_at);
				const newItemUpdatedDate = dayjs(this.item.updated_at);
				const isItemNewer = newItemUpdatedDate.isAfter(currentItemUpdatedDate);
				if (isItemNewer) {
				// if (this.localItem.is_play_live === this.item.is_play_live && this.localItem.is_update_live === this.item.is_update_live) {
					this.localItem = duplicateVar(this.item);
					if (this.status === 'live' && !this.isGoingToDie) {
						this.onPlayLive();
					} else {
					// eslint-disable-next-line no-lonely-if
						if (this.animationData && !this.isGoingToDie) {
							this.$nextTick(() => {
								try {
									this.updatelottieparam(this.animationData);
								} catch (error) {
								// console.log(error);
								}
							});
						}
					}
				// }
				}
			}
		},
	},
};
</script>
